module.exports = __webpack_public_path__ + "img/b1.bb21c03c.png";